module.exports = __webpack_public_path__ + "static/media/A-Z_2.21d9773e.png";